/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Media_Files_SelectedInputs */



/**
* | output |
* | --- |
* | "No media files selected" |
*
* @param {No_Media_Files_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_media_files_selected = /** @type {((inputs?: No_Media_Files_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Media_Files_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun fichier multimédia sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Mediendateien ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun file multimediale selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайлы не выбраны")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay archivos multimedia seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何媒体文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई मीडिया फ़ाइल चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum arquivo de mídia selecionado")
	return /** @type {LocalizedString} */ ("No media files selected")
});